/**
 * API base helpers for browser requests.
 *
 * - Prefer same-origin /api on Cloudflare Pages (no CORS, cookie-friendly)
 * - Allow override to absolute Worker URL when explicitly configured
 */

const envApiUrl = import.meta.env.VITE_API_URL;
const forceRelative =
  import.meta.env.VITE_FORCE_RELATIVE_API === '1' ||
  import.meta.env.VITE_FORCE_RELATIVE_API === 'true';

const isBrowser = typeof window !== 'undefined';
const isPagesHost =
  isBrowser && window.location.hostname.endsWith('pages.dev');

export const API_BASE =
  forceRelative || isPagesHost || !envApiUrl
    ? '/api'
    : `${envApiUrl}/api`;

export function resolveApiUrl(path: string): string {
  const normalized = path.startsWith('/api/')
    ? path.slice(4)
    : path;
  const suffix = normalized.startsWith('/') ? normalized : `/${normalized}`;
  return `${API_BASE}${suffix}`;
}

export function getApiOrigin(): string | null {
  if (API_BASE.startsWith('http')) {
    return new URL(API_BASE).origin;
  }

  if (isBrowser) {
    return window.location.origin;
  }

  return null;
}

export function getApiWebSocketOrigin(): string | null {
  const wsEnv =
    import.meta.env.VITE_WS_API_URL ||
    import.meta.env.VITE_API_URL;

  if (wsEnv && wsEnv.startsWith('http')) {
    return new URL(wsEnv).origin;
  }

  return getApiOrigin();
}
